import utils from '@ehi/global-marketing-interface/lib/utils';
import PROFILE from 'constants/profile';
/**
 * Compares PRP data code and users profile prefered program, if present, and returns if both programs are the same
 *
 * @param {object} profileData Authenticated user profile object, possibly with PRP data
 * @param {object} partnerRewardProgram Program complete data for a PRP page
 * @returns {boolean}
 */
export const profileProgramMatchPRP = (profileData, partnerRewardProgram) => {
  if (!profileData || !partnerRewardProgram) {
    return false;
  }
  const prpMatch = profileData?.partnerRewardsProgram?.code === partnerRewardProgram?.code;
  return !utils.isObjectEmpty(partnerRewardProgram) && prpMatch;
};

/**
 * Returns the boolean value if the array of error codes contains GBO error code
 *
 * @param {object} DUPLICATE_EMAIL_ERROR_CODES Array of error codes
 * @returns {boolean}
 */
export const isDuplicateEmailError = (errorCode) => PROFILE.DUPLICATE_EMAIL_ERROR_CODES.includes(errorCode);

/**
 * Returns the boolean value if the array of error code & priority equals GBO error code & priority
 *
 * @param {object} CROS_LOGIN_ACCOUNT_ERROR Object of error code & priority
 * @returns {boolean}
 */
export const isCrosLoginAccountError = (errorCode, errorPriority) =>
  PROFILE.CROS_LOGIN_ACCOUNT_ERROR.CODE === errorCode && PROFILE.CROS_LOGIN_ACCOUNT_ERROR.PRIORITY === errorPriority;
